// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"557":"1e4fdf5f","615":"1f28a6dc"}[chunkId] + ".chunk.js";
};